export default __webpack_public_path__ + "static/media/connect-illustration.534b8839.svg";